import {Reducer} from 'redux';
import initialState from './state';
import {IReduxAction, IReduxOrderProductFilesState as State} from '../../@interfaces';
import {ORDER_PRODUCT_FILE_PUSH, ORDER_PRODUCT_FILE_REMOVE} from './constants';

const reducer: Reducer = (state: State = initialState, action: IReduxAction): State => {
    switch (action.type) {
        case ORDER_PRODUCT_FILE_PUSH:
            return {
                ...state,
                uploadingFiles: {
                    ...state.uploadingFiles,
                    [action.payload.productCode]: [
                        ...(state.uploadingFiles[action.payload.productCode] ?? []),
                        ...action.payload.hashes,
                    ]
                }
            };

        case ORDER_PRODUCT_FILE_REMOVE:
            const list = state.uploadingFiles[action.payload.productCode]?.filter(
                hash => !action.payload.hashes?.includes(hash)
            ) ?? [];

            return {
                ...state,
                uploadingFiles: {
                    ...state.uploadingFiles,
                    [action.payload.productCode]: list
                }
            };

        default:
            break;
    }

    return state;
};

export default reducer;
